
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 3a4 4 0 100 8h10a4 4 0 000-8H7zm10 2a2 2 0 110 4H7a2 2 0 110-4h10zM7 13a4 4 0 000 8h10a4 4 0 000-8H7zm10 2a2 2 0 110 4H7a2 2 0 110-4h10z","fill":"currentColor"}})])
          )
        }
      }
    